<template>
  <main class="main view-gallery">

    <LoginModal v-if="$store.state.modal" @refreshGallery="refreshGall"></LoginModal>

    <Header />
    <EnterBanner></EnterBanner>
    <GalleryFilter @filterTileAmount="tilesToShow" @filterPayload="filter"></GalleryFilter>

    <div class="gallery" :class="[tileAmount, galleryLoading]">

      <article v-for="gallery of galleries" :key="gallery.id">
        <GalleryItem :itemObj="gallery">
        </GalleryItem>
      </article>

    </div>

    <div class="load-wrap">
      <button class="load-button" @click="loadMore">
        SCROLL TO LOAD MORE <img src="../assets/icon-down-yellow.svg">
      </button>
    </div>

  </main>
</template>

<script>
import LoginModal from '@/components/LoginModal'
import Header from '@/components/Header'
import EnterBanner from '@/components/EnterBanner'
import GalleryFilter from '@/components/GalleryFilter'
import GalleryItem from '@/components/GalleryItem'

export default {
  name: 'gallery',
  components: {
    LoginModal, Header, EnterBanner, GalleryFilter, GalleryItem
  },
  data () {
    return {
      galleries: [],
      filteredGalleries: null,
      galleryLoading: 'gallery-loading',
      tileAmount: 'small',
      filterPayload: {
        location: '',
        nameSearch: '',
        mood: '',
        sortBy: '',
        page: 1
      }
    }
  },
  created () {
    this.$store.state.isLoading = true
    this.$store.state.modal = false
    //
    this.refreshGall()
    //
    this.$http.getLocations()
  },
  mounted () {
  },
  methods: {
    tilesToShow (size) {
      this.tileAmount = size
    },
    refreshGall () {
      console.log('refreshme')
      this.$http.filter(this.filterPayload)
        .then((res) => {
          if (res.status !== undefined) {
            this.galleries = res.data.data
          } else {
            console.log('inside error', res.response.data.errors)
          }
        })
        .then(() => {
          setTimeout(() => {
            this.$store.state.isLoading = false
            this.galleryLoading = null
          }, 1000)
        })
    },
    refreshG (name) {
      console.log('refreshedID')
      console.log(name)
    },
    filter (payload) {
      this.$store.state.isLoading = true
      this.galleryLoading = 'gallery-loading'
      this.filterPayload = payload
      this.filterPayload.page = 1
      this.$http.filter(this.filterPayload)
        .then((res) => {
          if (res.status !== undefined) {
            this.galleries = res.data.data
            console.log(this.galleries)
          } else {
            console.log('inside error', res.response.data.errors)
          }
        })
        .then(() => {
          setTimeout(() => {
            this.$store.state.isLoading = false
            this.galleryLoading = null
          }, 1000)
        })
    },
    loadMore () {
      this.$store.state.isLoading = true
      this.galleryLoading = 'gallery-loading'
      this.filterPayload.page++
      console.log('load more', this.filterPayload)
      this.$http.filter(this.filterPayload)
        .then((res) => {
          if (res.status !== undefined) {
            this.galleries.push.apply(this.galleries, res.data.data)
            console.log(this.galleries)
          } else {
            console.log('inside error', res.response.data.errors)
          }
        })
        .then(() => {
          setTimeout(() => {
            this.$store.state.isLoading = false
            this.galleryLoading = null
          }, 1000)
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
.view-gallery {
  background: #1f1f1f;

  .gallery {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    padding: 0 3%;

    opacity: 1;
    transition: opacity 0.5s ease;

    article {
      width: calc(50% - 10px);
      margin: 0 0 36px;

      @media (min-width: $medium) {
        width: calc(33.33% - 36px);
      }
      @media (min-width: $mediumish) {
        width: calc(25% - 36px);
      }
    }
  }

  .gallery.gallery-loading {
    opacity: 0;
  }

  .gallery.small {
    article {
      @media (min-width: $largeish) {
        width: calc(17% - 18px);
      }
    }
  }

  .gallery.large {
    article {
      @media (min-width: $largeish) {
        width: calc(20% - 36px);
      }
    }
  }

  .load-wrap {
    display: inline-block;
    width: 100%;
    margin: 24px 0 48px;

    text-align: center;

    .load-button {
      font-size: 15px;
      font-weight: 400;
      text-transform: uppercase;
      color: white;

      img {
        display: inline-block;
        margin-left: 3px;
        transform: rotate(-90deg);
      }
    }
  }
}
</style>
